// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e1b67ae2","453":"bef732e3","455":"d6b2cd91"}[chunkId] + ".chunk.js";
};